<template>
  <div class="confirm-details-block">
    <p
      class="confirm-details-block__title"
      data-testid="confirm-details-block-title"
    >
      {{ title }}
    </p>
    <p
      v-for="(text, index) in texts"
      :key="index"
      class="confirm-details-block__text"
      data-testid="confirm-details-block-text"
    >
      {{ text }}
    </p>
    <TextLink :link="link" data-testid="confirm-details-block-link">
      Edit
    </TextLink>
  </div>
</template>

<script>
import TextLink from "@soenergy/frontend-library/src/components/TextLink.vue"

export default {
  components: { TextLink },
  props: {
    title: {
      type: String,
      default: null,
    },
    texts: {
      type: Array,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.confirm-details-block {
  font-size: $font-size-3;
  width: 100%;
  margin-bottom: $space-4;
  line-height: 1.5;

  &__title {
    font-weight: $weight-medium;
  }

  &__text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
